<template>
  <ul
    data-sidebar="menu"
    :class="cn('tw:flex tw:w-full tw:min-w-0 tw:flex-col tw:gap-1', props.class)"
  >
    <slot />
  </ul>
</template>

<script setup>
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  class: { type: null, required: false },
})
</script>
